/** Textes « factures » — le français fait foi. */
export const factures = {
  erreur: 'Erreur',
  titre: 'Factures',
  sousTitre: "Numérotation séquentielle inaltérable — une facture émise n'est jamais modifiée",
  emettre: 'Émettre une facture',
  vide: 'Aucune facture émise',
  colNumero: 'N°', colDate: 'Date', colType: 'Type', colClient: 'Client', colContrat: 'Contrat', colTotal: 'Total TTC',
  /** Le type stocké, tel qu'il s'affiche. */
  types: { acompte: 'acompte', solde: 'solde', avoir: 'avoir' } as Record<string, string>,
  dontTva: (pct: number | undefined) => `dont TVA ${pct} %`,
  dejaVerse: (m: string) => `déjà versé ${m}`,
  imprimer: 'Imprimer',
  explication: 'La facture est construite depuis le contrat : location, suppléments du départ, suppléments du retour, moins ce qui a déjà été encaisse.',
  avecTva: 'Facture avec TVA',
  avecTvaAide: '— à cocher pour une société, à décocher pour un particulier qui paie au comptoir',
  solde: (m: string) => `solde ${m}`,
  btnAcompte: 'Acompte',
  btnSolde: 'Solde',
};
